var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconfoundation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1788 53.3334V43.2801H10.0002V40.6134H15.1788V26.5254L6.94416 32.6667L5.3335 30.5547L32.0002 10.6667L58.7202 30.5547L57.1095 32.6667L48.8722 26.5227V40.6161H54.0002V43.2828H48.8722V53.3334H46.2055V43.2801H33.3335V53.3334H30.6668V43.2801H17.8455V53.3334H15.1788ZM17.8455 40.6134H30.6668V14.9921L17.8455 24.5601V40.6134ZM33.3335 40.6134H46.2055V24.5601L33.3335 14.9867V40.6134Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconfoundation);
export default __webpack_public_path__ + "static/media/Iconfoundation.e5702eba996f869644c2534bfeb51b46.svg";
export { ForwardRef as ReactComponent };